import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'center',
    gap: $theme.sizing.scale900,
    padding: $theme.sizing.scale700,
    marginTop: '25vh'
}))

export const TitleContainer = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: $theme.sizing.scale600
}))

export const Subtitle = styled('p', ({ $theme }) => ({
    margin: 0,
    ...$theme.typography.ParagraphMedium,
    textAlign: 'center'
}))

export const WemolonIcon = styled('i', ({ $theme }) => ({
    fontSize: '2.4rem',
    color: '#000',
    margin: '0 auto'
}))

export const Title = styled('h1', ({ $theme }) => ({
    margin: 0,
    ...$theme.typography.HeadingMedium,
    textAlign: 'center'
}))

export const ButtonContainer = styled('div', ({ $theme }) => ({
    marginTop: '1rem',
    display: 'flex',
    gap: '1.6rem',
    flexDirection: 'column'
}))
